<template>
  <base-view :activeTab="activeTab"></base-view>
</template>

<script>
export default {
  name: "cipher",
  data() {
    return {
      activeTab: "cipher"
    };
  },
  components: {
    BaseView: () => import("@/components/BaseView.vue"),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
